e.D = e.Dashboard = {
	init : function(){
		e.D.latest_posts.init();
		e.D.note_assignment_forms.init();
	}
};